<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Kelas Resume" @back="back">
            <a-descriptions bordered>
                <a-descriptions-item label="Materi Pelatihan">
                    <a-tooltip v-if="itemsSession != null">
                        <template slot="title">
                        Materi
                        </template>
                        <a-icon type="book" /> {{ itemsSession.material.name }}
                    </a-tooltip>
                    <br />
                    <a-tooltip v-if="itemsSession != null">
                        <template slot="title">
                        Inspirator
                        </template>
                        <a-icon type="user" /> {{ itemsSession.inspirator.name }}
                    </a-tooltip>
                </a-descriptions-item>
                <a-descriptions-item label="Tanggal mulai">
                    <template v-if="training_module.date_start != null">
                        {{ moment(training_module.date_start).format('DD MMMM YYYY') }}
                    </template>
                </a-descriptions-item>
                <a-descriptions-item label="Tanggal berakhir">
                    <template v-if="training_module.date_end != null">
                        {{ moment(training_module.date_end).format('DD MMMM YYYY') }}
                    </template>
                </a-descriptions-item>
                <a-descriptions-item label="Pelatihan">
                    {{ training.title }}
                </a-descriptions-item>
                <a-descriptions-item label="Deskripsi">
                    {{ training.description }}
                </a-descriptions-item>
                <a-descriptions-item label="Status">
                    <div v-if="!loading && items.attendant_resumes.length > 0">
                        <div v-if="resumeVerifyLevel > 0">
                            <a-row type="flex" :gutter="[8,8]">
                                <a-col flex="1 1 200px">
                                    <a-tag
                                            :color="colorLevel">
                                        Validasi Level {{ roleLevel(resumeVerifyLevel) }}
                                    </a-tag>
                                </a-col>
                                <a-col flex="0 1 300px">
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        v-if="resumeVerifyLevel == resumeRoleLevel"
                                        @click="showConfirm"
                                    >Validasi</a-button>
                                </a-col>
                            </a-row>
                        </div>
                        <div v-else>
                            <a-row type="flex" :gutter="[8,8]">
                                <a-col flex="1 1 200px">
                                    <a-tag color="red">
                                        belum divalidasi
                                    </a-tag>
                                </a-col>
                                <a-col flex="0 1 300px">
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        @click="showConfirm"
                                        >Validasi</a-button
                                    >
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </a-descriptions-item>
            </a-descriptions>
        </a-page-header>

        <a-card type="inner" size="small">
            <div style="margin-bottom: 16px; text-align: right;" v-show="roleAdmin || ispmbk">
                <a-button type="primary" @click="download(routeUri('api.classical-resumes.attendant.resumes', {class:items.session.class_id, session:items.session.id}) + '?export=1')">
                    Download
                </a-button>
            </div>
            <a-table
                class="pcp-table"
                :dataSource="items.attendant_resumes"
                rowKey="hash"
                :loading="loading"
                :pagination="false"
                bordered>

                <a-table-column key="photo" title="Foto" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div style="text-align: center">
                            <img :src="record.photo" v-if="record.photo != null" width="70px" />
                            <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <a-table-column key="gender" title="Gender" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ gender(record.gender) }}
                    </template>
                </a-table-column>

                <a-table-column key="attachment" title="File" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].resumes.length >= 1 ">
                            <a-button type="link" icon="video-camera" size="small" @click="download(record.activities[0].resumes[0].attachment)">
                                Download
                            </a-button>
                        </div>
                        <div v-else>
                            <a-tooltip title="Upload resume">
                                <a-button type="dashed" icon="upload" size="small"  @click="showModalResume(record.hash)">
                                    Upload
                                </a-button>
                            </a-tooltip>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="uploaded_time" title="Tanggal Upload" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <template v-if="record.activities[0].resumes.length > 0 && record.activities[0].resumes[0].upload_time != null">
                            {{ moment(record.activities[0].resumes[0].upload_time).format('DD MMM YYYY HH:mm:ss') }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="file_last_update" title="Tanggal Reupload" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <template v-if="record.activities[0].resumes.length > 0 && record.activities[0].resumes[0].reupload_time != null">
                            {{ moment(record.activities[0].resumes[0].reupload_time).format('DD MMM YYYY HH:mm:ss') }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="score" title="Nilai" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <template v-if="record.activities[0].scores.length > 0">
                            {{ record.activities[0].scores[0].raw_score }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="resumeVerifyLevel == resumeRoleLevel">
                            <a-tooltip :title="resumeRoleLevel == 2 ? 'Adjustment Penilaian' : 'Penilaian'">
                                <a-button
                                    :disabled="examVerifyLevel > 2 &&
                                        resumeVerifyLevel == 3"
                                    style="margin-right: 4px"
                                    size="small"
                                    type="primary"
                                    icon="up-square"
                                    @click="showModal(record.hash)"
                                />
                            </a-tooltip>
                        </div>
                        <div v-if="roleAdmin && itemsSession.classical_verification_level >= 1">
                            <a-tooltip title="Adjustment Penilaian">
                                <a-button
                                    :disabled="itemsSession.classical_verification_level > 1"
                                    style="margin-right: 4px"
                                    size="small"
                                    type="primary"
                                    icon="up-square"
                                    @click="showModal(record.hash)"
                                />
                            </a-tooltip>
                        </div>
                    </template>
                </a-table-column>
            </a-table>
        </a-card>

        <a-modal
            :visible="visibleResume"
            :destroyOnClose="true"
            :footer="null"
            :closable="false"
        >
            <classical-upload-resume
                :session="session"
                :attendant="attendant"
                @handleClose="closeModal"
            />
        </a-modal>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
            width="30%"
        >
            <classical-scoring-resume-form
                :user_hash="attendant"
                :material="material"
                :edit="true"
                @handleClose="closeModal"
            />
        </a-modal>

    </div>
</template>

<script>
export default {
    props: {
        class_id: {
            type: String,
            required: true
        },
        session: {
            type: String,
            required: true
        },
        previous: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            expand: false,
            visible: false,
            visibleResume: false,
            resumes: {},
            processing: false,
            attendant: null,
            items: {
                attendant_resumes: []
            },
            filters: {
                q: null,
                email: null,
                page: 1
            }
        };
    },
    created() {
        this.items = this.getDefaultPagination();
        this.filters = _.merge(this.filters, this.$laravel.request);
        this.getItems();
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        training() {
            return this.$laravel.training
        },
        itemsSession() {
            return this.items.session != null ? this.items.session : null
        },
        training_module() {
            return this.$laravel.training_modules.classical
        },
        roleAdmin() {
            let role = this.$laravel.roles[this.activeModule.module.identifier]

            role = typeof role === "string" ? role : role[0]

            return role == 'admin'
        },
        tableColumns() {
            return this.columns
        },
        material(){
            return this.itemsSession != null ? this.itemsSession.material_id.toString() : ""
        },
        resumeVerifyLevel(){
            return this.itemsSession != null ? this.itemsSession.resume_verification_level.toString() : ""
        },
        examVerifyLevel(){
            return this.itemsSession != null ? this.itemsSession.exam_verification_level.toString() : ""
        },
        isResumesComplete(){
            var arrResume = this.items.attendant_resumes.filter(function(ele){
                return (ele.activities[0].resumes.length === 0)
            });

            return arrResume.length
        },
        isScoresComplete(){
            var arrScores = this.items.attendant_resumes.filter(function(ele){
                return (ele.activities[0].scores.length === 0)
            });

            return arrScores.length
        },
        resumeRoleLevel(){
            let role = this.$laravel.roles[this.activeModule.module.identifier]

            let level = 0

            switch(role){
                case "project-manager":
                    level = 2
                    break
                case "inspirator":
                    level = 1
                    break
            }

            return level
        },
        colorLevel(){
            if(this.resumeVerifyLevel > 2)
                return 'green'

            return 'orange'
        },
        ispmbk(){
            return this.$laravel.roles[this.activeModule.module.identifier] == 'project-manager'
        },
    },
    methods: {
        handleSubmit(e) {
           e.preventDefault(e);

            this.processing = true;

            let promise;

            if(this.resumeVerifyLevel == ""){
                this.processing = false;
                return
            }

            promise = this.$http.put(
                this.routeUri("api.classical-resumes.verify_resume", {
                    session: this.session
                }),
                {
                    level: parseInt(this.resumeVerifyLevel)+1
                }
            );

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleReset(e) {
            e.preventDefault();
            this.filters = {
                q: null,
                page: 1
            };
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current;
            this.pushState(this.filters);
            this.getItems();
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-resumes.attendant.resumes", {session: this.session, class: this.class_id}))
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.getItems();
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        showModal(attendant) {
            this.attendant = attendant;
            this.visible = true;

        },
        showModalResume(attendant) {
            this.attendant = attendant;
            this.visibleResume = true;
        },
        closeModal(isRefresh) {
            this.visible = false;
            this.visibleResume = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
        download(url) {
            window.open(url, '_blank')
        },
        showConfirm(e) {
            if(this.resumeVerifyLevel == 0 && this.isResumesComplete > 0){
                this.processing = false;
                this.$warning({
                    title: 'Peringatan',
                    content: this.isResumesComplete + ' Peserta belum upload resume!',
                });

                return
            }

            if(this.resumeVerifyLevel == 1 && this.isScoresComplete > 0){
                this.processing = false;
                this.$warning({
                    title: 'Peringatan',
                    content: this.isScoresComplete + ' Peserta belum mendapat nilai!',
                });

                return
            }

            var msg = 'Apakah Anda yakin untuk melanjutkan proses validasi?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.handleSubmit(e)
                },
                onCancel() {},
                class: 'test',
            });
        },
        back() {
            window.location.href = this.routeUri(this.previous)
        },
        roleLevel(level){
            switch (level) {
                case "1":
                    return "1 - PM BK"
                case "2":
                    return "2 - Inspirator"
                case "3":
                    return "3 - PM BK"
            }
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        }
    },
}
</script>
